import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { DashboardShellProvider } from '../context/DashboardShellContext';
import BaseDashboardLayout from './BaseDashboardLayout';
import { getAdminNavSections } from '../components/Sidebar/roleNavConfig';

const AdminLayout = () => {
  const sections = useMemo(() => getAdminNavSections(), []);
  const shell = useMemo(
    () => ({
      homePath: '/admin/overview',
      workspacePath: '/admin/overview',
      profilePath: '/admin/profile',
      projectBasePath: null,
      codingRoot: '/admin',
      codingActivityPath: null,
    }),
    [],
  );

  return (
    <DashboardShellProvider value={shell}>
      <BaseDashboardLayout brandPath="/admin/overview" sections={sections}>
        <Outlet />
      </BaseDashboardLayout>
    </DashboardShellProvider>
  );
};

export default AdminLayout;
